"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LedgerSigner = void 0;
var utility_1 = require("../utility");
var crypto_1 = require("@cosmjs/crypto");
var amino_1 = require("@cosmjs/amino");
/**
 * LedgerSigner implements the logic for the Ledger device signer
 */
var LedgerSigner = /** @class */ (function () {
    /**
     * Creates a new Ledger device signer instance
     * @param {LedgerConnector} connector the Ledger connector
     * @param {number} accountIndex the desired account index
     * @param {string} addressPrefix the address prefix
     */
    function LedgerSigner(connector, accountIndex, addressPrefix) {
        var _this = this;
        if (addressPrefix === void 0) { addressPrefix = utility_1.defaultAddressPrefix; }
        this.getAddress = function () { return __awaiter(_this, void 0, void 0, function () {
            var compressedPubKey;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.connector) {
                            throw new Error('Ledger not connected');
                        }
                        return [4 /*yield*/, this.connector.getPubkey(this.hdPath)];
                    case 1:
                        compressedPubKey = _a.sent();
                        return [2 /*return*/, (0, amino_1.pubkeyToAddress)((0, amino_1.encodeSecp256k1Pubkey)(compressedPubKey), this.addressPrefix)];
                }
            });
        }); };
        this.getPublicKey = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!this.connector) {
                    throw new Error('Ledger not connected');
                }
                return [2 /*return*/, this.connector.getPubkey(this.hdPath)];
            });
        }); };
        this.getPrivateKey = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                throw new Error('Ledger does not support private key exports');
            });
        }); };
        this.signData = function (data) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!this.connector) {
                    throw new Error('Ledger not connected');
                }
                return [2 /*return*/, this.connector.sign(data, this.hdPath)];
            });
        }); };
        this.verifySignature = function (data, signature) { return __awaiter(_this, void 0, void 0, function () {
            var publicKey;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getPublicKey()];
                    case 1:
                        publicKey = _a.sent();
                        return [2 /*return*/, crypto_1.Secp256k1.verifySignature(crypto_1.Secp256k1Signature.fromFixedLength(signature), (0, crypto_1.sha256)(data), publicKey)];
                }
            });
        }); };
        this.connector = connector;
        this.hdPath = (0, utility_1.generateHDPath)(accountIndex);
        this.addressPrefix = addressPrefix;
    }
    return LedgerSigner;
}());
exports.LedgerSigner = LedgerSigner;
